import React, { useEffect } from 'react';
import { Form, Input, InputNumber, Button, Row, Col } from 'antd';

const GenericNTAForm = ({ fields, selectedItem, onSubmit, onCancel, submitLoading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (selectedItem) {
      form.setFieldsValue(selectedItem);
    } else {
      form.resetFields();
    }
  }, [selectedItem, form]);

  return (
    <Form
      form={form}
      layout='vertical'
      onFinish={onSubmit}
      style={{ padding: '16px' }}
    >
      {fields.map(field => (
        <Form.Item key={field.key} name={field.key} label={field.label}>
          {field.type === 'number' ? (
            <InputNumber style={{ width: '100%' }} />
          ) : field.type === 'textarea' ? (
            <Input.TextArea rows={3} />
          ) : (
            <Input />
          )}
        </Form.Item>
      ))}
      <Row gutter={8} justify='end' style={{ marginTop: 8 }}>
        <Col>
          <Button onClick={onCancel}>Cancel</Button>
        </Col>
        <Col>
          <Button type='primary' htmlType='submit' loading={submitLoading}>
            {selectedItem ? 'Update' : 'Add'}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default GenericNTAForm;
